<!--
 * @Description: 问卷、可配置详情
 * @Date: 2021-10-23 16:36:32
-->
<template>
  <div class="detail-21">
    <el-form-item
      v-for="(item, index) in detail.values"
      :label="labelFilter(item, index)"
      :key="index"
    >
      <div class="item-p" v-if="item.remark" style="color:grey;font-size:14px;">
        备注：{{ item.remark }}
      </div>
      <!-- 目标题 -->
      <template v-if="!item.topicType">
        <img
          class="pointer img-50"
          v-if="getFileType(item.values) === 'image'"
          @click="onFileViewerItem(item.values)"
          :src="item.values"
        />
        <div class="item-p item-pre" v-else>{{ item.values }}</div>
      </template>
      <!-- 普通题 -->
      <template v-else>
        <div
          class="item-p"
          v-if="deal(item.values) && ![17, 18].includes(item.topicType)"
        >
          无
        </div>

        <div
          v-if="typeof item.values == 'object' && item.topicType < 8"
          class="item-p"
        >
          <div
            v-if="item.values.length > 0"
            v-for="(item2, index2) in item.values"
            :key="index2 + 100"
          >
            <p v-if="item.topicType == 5" style="margin-bottom:10px;">
              {{ item.manyTitleJson[index2] }}：
            </p>
            <p style="margin-bottom:10px;">{{ item2 ? item2 : '无' }}</p>
          </div>
          <div v-else>无</div>
        </div>
        <div class="enclosure" v-else-if="item.topicType == 8">
          <template
            v-for="(item2, index2) in item.values"
            v-if="item.values.length > 0"
          >
            <img
              class="pointer img-50"
              v-if="!item2.isPdf"
              :key="index2 + 100"
              :src="item2.url"
              @click="onFileViewerItem(item2.url)"
            />
            <div
              v-else
              class="pointer"
              @click="onFileViewerItem(item2.url)"
              :key="index2 + 100"
            >
              <img src="//cdn.yxvzb.com/WEB/images/pdf.jpeg" />
              <span>{{ item2.name }}</span>
            </div>
          </template>
          <div v-else>无</div>
        </div>
        <div
          v-else-if="fileTypeList.includes(item.topicType)"
          style="display:flex;flex-wrap:wrap;width:100%"
        >
          <div
            class="item-p"
            v-for="(item2, index2) in item.values"
            :key="index2"
            v-if="item.values.length > 0"
          >
            <img
              class="pointer img-50"
              style="margin:5px;"
              v-if="item.topicType == 13"
              :src="item2.url"
              @click="onFileViewerItem(item2.url)"
            />
            <div
              class="pointer"
              v-else
              @click="onFileViewerItem(item2.url)"
              :key="index2 + 100"
            >
              <span style="color:#409eff">{{ item2.name }}</span>
            </div>
          </div>
          <div v-else>无</div>
        </div>
        <div v-else-if="timeTypeList.includes(item.topicType)">
          <p class="item-p">{{ item.values }}</p>
        </div>
        <div v-else-if="item.topicType == 16" class="item-p">
          <img
            class="pointer img-50"
            style="margin:5px;"
            v-if="item.values.addressPicUrl"
            :src="item.values.addressPicUrl"
            @click="onFileViewerItem(item.values.addressPicUrl)"
          />
        </div>

        <div class="item-p" v-else-if="item.topicType == 20">
          <img
            class="pointe img-50"
            style="margin:5px;"
            v-if="item.values"
            :src="item.values"
            @click="onFileViewerItem(item.values)"
          />
        </div>
        <div class="item-p item-pre" v-else>
          {{ item.values === 'null' ? '无' : item.values }}
        </div>
      </template>
    </el-form-item>
  </div>
</template>

<script>
import { questionType } from '@/config/staticData';
import table5_7 from './table-5_7.vue';
import { getFileType } from '@R/services/set-file-viewer-list';
import myIframe from '@R/components/iframe';
import createExtend from '@C/createExtend';

export default {
  name: 'detail-21',
  props: {
    detail: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  inject: ['row'],
  components: { table5_7 },
  data() {
    return {
      fileTypeList: [8, 9, 10, 11, 12, 13],
      timeTypeList: [14, 15],
      iframe: null
    };
  },
  watch: {
    detail: {
      immediate: true,
      handler(v) {
        if (v && v.values) {
          this.detail.values.forEach(item => {
            // 只对普通题处理
            if (item.topicType) {
              item.manyTitleJson = item.manyTitleJson || '[]';
              if (
                item.topicType == 2 ||
                item.topicType == 5 ||
                (item.topicType >= 8 && item.topicType != 19)
              ) {
                try {
                  item.values = JSON.parse(item.values);
                } catch (error) {
                  console.error(error);
                }
                if (item.topicType == 5) {
                  try {
                    item.manyTitleJson = JSON.parse(item.manyTitleJson);
                  } catch (error) {
                    console.error(error);
                  }
                }
              }
            }
          });
        }
      }
    }
  },
  methods: {
    getFileType,
    onFileViewerItem(url) {
      const fileType = getFileType(url);
      if (fileType === 'image') {
        this.$emit('onFileViewerItem', url);
      } else {
        this.$previewFile(url);
        return;
      }
    },
    labelFilter(item, index) {
      let type, typeName, mustName;
      let {
        isSetTarget,
        isSetTime,
        isSetLocation,
        topicType,
        isMustFill,
        label
      } = item;
      type = topicType;
      // 场景题
      if (!item.topicType) {
        isSetTarget && (type = -1);
        isSetTime && (type = -2);
        isSetLocation && (type = -3);
      }
      typeName = (questionType[type] || { label: '' }).label;
      typeName = typeName ? `[${typeName}]` : '';
      mustName = isMustFill || !item.topicType ? '(必填)' : '(非必填)';
      return `${index + 1}.${label}${typeName}${mustName}`;
    },
    deal(v) {
      if (v === undefined || v === null || v === '' || v.length === 0) {
        return true;
      } else {
        return false;
      }
    }
  },
  mounted() {
    if (this.detail.projectType === 21) {
      let src = `${process.env.VUE_APP_WEBVIEW}/v3/index.html#/digital-questionnaire/detail?platformType=oss&recordId=${this.detail.taskId}`;
      this.iframe = createExtend(myIframe, {
        src: src
      });
      this.iframe.$el.style.position = 'fixed';
      this.iframe.$el.style.left = '16%';
      this.iframe.$el.style.top = '5vh';
      this.iframe.$el.style.width = '540px';
      this.iframe.$el.style.zIndex = '20000';
    }
  },
  destroyed() {
    if (this.detail.projectType === 21) {
      if (this.iframe) {
        document.body.removeChild(this.iframe.$el);
      }
    }
  }
};
</script>

<style scoped lang="scss">
.detail-21 {
  .img-50 {
    width: 80px;
  }

  >>> .el-form-item__label {
    font-size: 16px;
    //font-weight: bold;
    text-align: left;
    display: block;
    width: 100% !important;
  }

  >>> .el-form-item__content {
    display: block !important;
  }
}
</style>
